"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetBucketRequestPaymentOutput = {
    type: "structure",
    required: [],
    members: {
        Payer: {
            shape: {
                type: "string"
            }
        }
    }
};
//# sourceMappingURL=GetBucketRequestPaymentOutput.js.map